<script>
export default {
  name: 'ArrowUpNewUx',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#4B4B4B',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.08025 15.8203L12.3103 15.8203L17.9203 15.8203C18.8803 15.8203 19.3603 14.6603 18.6803 13.9803L13.5003 8.80031C12.6703 7.97031 11.3203 7.97031 10.4903 8.80031L8.52025 10.7703L5.31025 13.9803C4.64025 14.6603 5.12025 15.8203 6.08025 15.8203Z"
      :fill="color"
    />
  </svg>
</template>
